/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ObligationStatus = {
    Open: 'Open',
    Paid: 'Paid',
    HeldForReview: 'HeldForReview',
    Expired: 'Expired',
    Waived: 'Waived',
    Cancelled: 'Cancelled'
} as const;
export type ObligationStatus = typeof ObligationStatus[keyof typeof ObligationStatus];

